import * as React from 'react';
export const IcYogaMeditation = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 6a2 2 0 100-4 2 2 0 000 4zm6.76 11L12 18.72 5.24 17a1.028 1.028 0 10-.48 2l3.12.78-1.12.22A1.007 1.007 0 107 22c.08.01.16.01.24 0L12 20.78 16.76 22a1 1 0 001.24-.76 1.001 1.001 0 00-.76-1.24l-1.12-.28 3.12-.72a1.028 1.028 0 00-.48-2zM5 16a.93.93 0 00.45-.11l1.26-.63a3 3 0 001.5-1.73l1.28-3.85a1 1 0 01.95-.68H11v8.41l1 .25 1-.25V9h.56a1 1 0 01.95.68l1.28 3.85a3 3 0 001.5 1.73l1.26.63A.93.93 0 0019 16a1 1 0 00.45-1.89l-1.26-.63a1 1 0 01-.5-.58L16.4 9.05A3 3 0 0013.56 7h-3.12A3 3 0 007.6 9.05L6.31 12.9a1 1 0 01-.5.58l-1.26.63A1 1 0 005 16z'
      fill='currentColor'
    />
  </svg>
);
